<template>
  <el-row class="full-page-body">
    <lgy-container class="container-register">
      <el-row class="register-box">
        <p class="header">
          新用户注册
        </p>
        <el-row type="flex" justify="center">
          <el-row
            class="width-56 mt-30 pb-60"
            style="margin-left: -5.375rem;overflow: hidden;"
          >
            <el-form
              ref="form"
              :model="form"
              label-width="230px"
              :rules="rules"
              enctype="multipart/form-data"
              @submit.prevent="validateForm()"
            >
              <el-col>
                <el-form-item label="企业名称" prop="custSupplierName">
                  <el-input
                    v-model="form.custSupplierName"
                    placeholder="请输入企业名称"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="统一社会信用代码" prop="certificateCode">
                  <el-input
                    v-model="form.certificateCode"
                    placeholder="请输入统一社会信用代码"
                    @blur="checkIsRegiter(1)"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="电子邮箱" prop="email">
                  <el-input
                    v-model="form.email"
                    :maxlength="255"
                    placeholder="请输入电子邮箱"
                    @blur="checkIsRegiter(2)"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="密码" prop="password">
                  <el-input
                    v-model="form.password"
                    type="password"
                    placeholder="请输入密码"
                    autocomplete="new-password"
                  />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="确认密码" prop="confirmPassword" required>
                  <el-input
                    v-model="form.confirmPassword"
                    type="password"
                    placeholder="请确认密码"
                    autocomplete="new-password"
                  />
                </el-form-item>
              </el-col>
              <el-col class="align-left">
                <el-form-item label="企业营业执照" prop="zhizhao">
                  <el-upload
                    v-if="!file"
                    :on-change="handleChange"
                    :before-upload="beforUpload"
                    action="/"
                    :auto-upload="false"
                    :show-file-list="false"
                  >
                    <el-button type="primary" size="mini">
                      上传文件
                    </el-button>
                  </el-upload>
                  <el-col v-if="file">
                    <span class="pr-20 break-line">
                      {{ file.name }}
                    </span>
                    <el-button size="mini" type="danger" @click="deleteFile">
                      删除
                    </el-button>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col class="align-left">
                <el-form-item label="管理人员授权书" prop="powerAttorney">
                  <el-row v-if="!powerAttorney">
                    <el-col :span="4">
                      <el-upload
                        :on-change="handleBizLicensePicChange"
                        action="/"
                        :auto-upload="false"
                        :show-file-list="false"
                      >
                        <el-button type="primary" size="mini">
                          上传文件
                        </el-button>
                      </el-upload>
                    </el-col>
                    <el-col :offset="1" :span="4">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="download(1)"
                      >
                        下载授权书模板
                      </el-button>
                    </el-col>
                  </el-row>
                  <el-col v-if="powerAttorney">
                    <span class="pr-20 break-line">
                      {{ powerAttorney.name }}
                    </span>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="deleteBizLicenseFile"
                    >
                      删除
                    </el-button>
                  </el-col>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item label="授权管理员手机" prop="phonenumber">
                  <el-input
                    v-model.number="form.phonenumber"
                    placeholder="请输入手机号码"
                    @blur="checkIsRegiter(0)"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item label="图形验证码" prop="imgCode">
                  <el-input
                    v-model="form.imgCode"
                    placeholder="请输入图形验证码"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <!-- <img
                  class="form-img"
                  :src="`data:image/png;base64,${imgUrl}`"
                  @click="getImgCode"
                /> -->
                <img
                  class="form-img"
                  :src="`data:image/png;base64,${imgUrl}`"
                  @click="getImgCode"
                />
              </el-col>
              <el-col :span="17">
                <el-form-item label="短信证码" prop="smsCode">
                  <el-input
                    v-model="form.smsCode"
                    placeholder="请输入短信验证码"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6" :offset="1">
                <el-button
                  :disabled="btnDisabled"
                  type="info"
                  class="width-100"
                  @click="getMsgCode"
                >
                  {{ btnMsg }}
                </el-button>
              </el-col>
              <el-col class="large-btn">
                <el-form-item>
                  <p class="zhengce">
                    <el-checkbox v-model="agree">
                      我已同意
                    </el-checkbox>
                    <span class="file-span" @click="download(6)">
                      《供商连共享平台用户服务协议》
                    </span>
                    <span>
                      和
                    </span>
                    <span class="file-span" @click="download(7)">
                      《供商连共享平台隐私政策》
                    </span>
                  </p>
                  <el-button
                    class="width-100"
                    type="primary"
                    @click="validateForm"
                  >
                    立即注册
                  </el-button>
                  <p class="align-left tip">
                    注册完成后，会有2-3工作日进行企业实名审核，请您及时关注邮
                    箱审核结果。
                  </p>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </el-row>
      </el-row>
    </lgy-container>
    <el-dialog
      v-if="visible"
      :title="title"
      :visible.sync="visible"
      width="650px"
    >
      <el-row class="ql-container">
        <el-col class="ql-editor" v-html="dialogContent" />
        <el-col class="mt-30 align-right">
          <el-button type="info" @click="visible = false">
            关闭
          </el-button>
        </el-col>
      </el-row>
    </el-dialog>
  </el-row>
</template>

<script>
import imgAPI from '@/http/login'
import smsAPI from '@/http/sms'
import api from '@/http/merchant/register'
import introAPI from '@/http/sys/introduction'

export default {
  data() {
    var validateCheckPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    return {
      title: '',
      visible: false,
      dialogContent: '',
      rules: {
        custSupplierName: [
          { required: true, message: '请输入企业名称', trigger: 'blur' },
          { max: 255, message: '最大支持255位', trigger: 'change' }
        ],
        certificateCode: [
          {
            required: true,
            message: '请输入统一社会信用代码',
            trigger: 'blur'
          },
          {
            pattern: /^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/,
            message: '请輸入正确格式的统一社会信用代码',
            trigger: 'blur'
          }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          },
          { max: 255, message: '最大支持255位', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, message: '密码不能小于6位数', trigger: 'change' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { min: 6, message: '密码不能小于6位数', trigger: 'change' },
          { validator: validateCheckPass, trigger: 'change' }
        ],
        zhizhao: [
          { required: true, message: '请上传营业执照', trigger: 'blur' }
        ],
        powerAttorney: [
          { required: true, message: '管理人员授权书', trigger: 'blur' }
        ],
        phonenumber: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { pattern: /^1[0-9]{10}$/, message: '请输入正确的中国大陆的手机号码' }
        ],
        imgCode: [
          { required: true, message: '请输入图形验证码', trigger: 'blur' }
        ],
        smsCode: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ]
      },
      agree: false,
      timer: null,
      imgUrl: '',
      btnMsg: '获取短信验证码',
      btnDisabled: false,
      form: {
        custSupplierName: '',
        certificateCode: '',
        email: '',
        password: '',
        checkPass: '',
        phonenumber: '',
        imgCode: '',
        zhizhao: [],
        powerAttorney: ''
      },
      powerAttorney: null,
      file: null,
      url: `${this.url}`
    }
  },
  mounted() {
    this.getImgCode()
    if (localStorage.regMsgTime) {
      const now = new Date().getTime()
      const time = parseInt((now - localStorage.regMsgTime) / 1000)
      if (time < 120) {
        this.beginTimer(120 - time)
      }
    }
  },
  methods: {
    getImgCode() {
      imgAPI.getImgCode().then(res => {
        if (res.code === this.sucCode) {
          this.imgUrl = res.img
          this.form.uuid = res.uuid
        }
      })
    },
    download(type) {
      const tem = '/prod-api/file/downloadTemplate'
      let url = ''
      switch (type) {
        case 1:
          url = `${tem}/授权书.doc`
          window.open(url)
          break
        case 6:
          this.title = '供商连共享平台用户服务协议'
          this.getFileConent(type)
          break
        case 7:
          this.title = '供商连共享平台隐私政策'
          this.getFileConent(type)
          break
      }
    },
    getFileConent(type) {
      this.$loading()
      introAPI.queryByType({ type }).then(
        res => {
          this.$loading().close()
          if (res.code === this.sucCode) {
            this.dialogContent = res.data.content
            this.visible = true
          } else {
            this.$message.info(res.msg)
          }
        },
        () => {
          this.$loading().close()
        }
      )
    },
    getMsgCode() {
      if (!this.form.phonenumber) {
        this.$message.error('请输入手机号码！')
        return
      }
      if (!this.form.imgCode) {
        this.$message.error('请先输入图形验证码')
        return
      }
      smsAPI
        .getSms(
          {
            code: this.form.imgCode,
            uuid: this.form.uuid
          },
          this.form.phonenumber
        )
        .then(
          res => {
            if (res.code === this.sucCode) {
              this.$message.success('短信已发送，请注意查收！')
              this.beginTimer()
              localStorage.regMsgTime = new Date().getTime()
            } else {
              this.getImgCode()
              this.$message.error(res.msg)
            }
          },
          () => {
            this.getImgCode()
            this.$message.error('请稍后重试！')
          }
        )
    },
    checkIsRegiter(type) {
      const obj = {
        type,
        param: ''
      }
      switch (type) {
        case 0:
          obj.param = this.form.phonenumber
          break
        case 1:
          obj.param = this.form.certificateCode
          break
        case 2:
          obj.param = this.form.email
          break
      }
      if (obj.param === '') {
        return
      }
      api.checkParamsUnique(obj).then(res => {
        if (res.code !== this.sucCode) {
          this.$message.error(res.msg)
        }
      })
    },
    beginTimer(tag = 120) {
      this.btnDisabled = true
      this.btnMsg = `请稍后重试(${tag})`
      this.timer = setInterval(() => {
        if (tag > 0) {
          tag--
          this.btnMsg = `请稍后重试(${tag})`
        } else {
          this.btnMsg = `获取短信验证码`
          this.btnDisabled = false
          localStorage.removeItem('regMsgTime')
          clearInterval(this.timer)
        }
      }, 1000)
    },
    // 验证表单
    validateForm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submit()
        } else {
          this.$message.error('请检查注册表单')
          return false
        }
      })
    },
    submit() {
      if (!this.agree) {
        this.$alert(
          '请先同意 《供商连共享平台用户服务协议》和《供商连共享平台隐私政策》',
          '提示',
          {
            confirmButtonText: '确定'
          }
        )
        return
      }
      const obj = { ...this.form }
      delete obj.imgCode
      delete obj.zhizhao
      delete obj.powerAttorney
      let fd = new FormData()
      for (const key in obj) {
        fd.append(key, obj[key])
      }
      fd.append('powerAttorney', this.powerAttorney.raw)
      fd.append('bizLicensePic', this.file.raw)
      this.$loading()
      this.$axios.post(`${this.globalUrl}merchant/register/review`, fd).then(
        res => {
          this.$loading().close()
          if (res.data.code === this.sucCode) {
            this.$message.success('注册成功！')
            this.$router.push({ path: '/login' })
          } else {
            this.getImgCode()
            this.$message.error(res.data.msg)
          }
        },
        error => {
          this.getImgCode()
          this.$message.success(`请稍后重试！${error}`)
        }
      )
    },
    beforUpload(file) {
      const arr = ['image/jpeg', 'image/png', 'image/jpg']
      const isImage = arr.includes(file.type)
      if (!isImage) {
        this.$message.error('请上传正确格式的图片！')
      }
      return isImage
    },
    deleteFile() {
      this.file = null
      this.form.zhizhao = ''
    },
    deleteBizLicenseFile() {
      this.powerAttorney = null
      this.form.powerAttorney = ''
    },
    handleBizLicensePicChange(file) {
      const arr = ['image/jpeg', 'image/png', 'image/jpg']
      const isImage = arr.includes(file.raw.type)
      if (!isImage) {
        this.$message.error('请上传正确格式的图片！')
        return isImage
      } else {
        this.powerAttorney = file
        this.form.powerAttorney = file.name
      }
    },
    handleChange(file) {
      const arr = ['image/jpeg', 'image/png', 'image/jpg']
      const isImage = arr.includes(file.raw.type)
      if (!isImage) {
        this.$message.error('请上传正确格式的图片！')
        return isImage
      } else {
        this.file = file
        this.form.zhizhao = file.name
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.full-page-body {
  background: url('~@/assets/img/registerBack.png') 100% 100%;
}
.container-register {
  height: auto;
  padding-bottom: 90px;
}
.register-box {
  margin: 50px auto 90px;
  width: 100%;
  min-height: 850px;
  box-shadow: 0px 12px 12px rgba(0, 153, 255, 0.16);
  background: white;
  .header {
    margin: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 1.75rem;
    border-bottom: 1px solid $borderColor;
    text-align: center;
  }
  .tip {
    margin: 20px 0 0;
    font-size: 0.75rem;
    line-height: 20px;
    color: $primary;
  }
  .form-img {
    height: 40px;
    width: 100%;
  }
  .zhengce {
    font-size: 0.75rem;
    color: #828584;
    .file-span {
      color: $primary;
      cursor: pointer;
    }
    &::v-deep {
      .el-checkbox__label {
        font-size: 0.75rem;
        color: #828584;
      }
    }
  }
  .large {
    &::v-deep {
      .el-button {
        font-size: 1.25rem;
        padding-top: 11px;
        padding-bottom: 11px;
      }
    }
  }
}

</style>
